import React from 'react';
import { Tooltip } from '@mui/material';
import EditCloneDeleteMenu from "../../Menus/EditCloneDeleteMenu";



export const PlatformGridColumns = ({ hideActions, onEdit, onClone, onDelete }) => [
    {
        field: "more",
        headerName: '',
        width: 20,
        sortable: false,
        filterable: false,
        hide: hideActions,
        renderCell: (params) => (
            <Tooltip title={`Click to see actions for record ${params.row.id}`}>
                <EditCloneDeleteMenu
                    onEdit={() => onEdit(params.row)}
                    onClone={() => onClone(params.row)}
                    onDelete={() => onDelete(params.row)}
                />
            </Tooltip>
        )
    },
    {    field: 'id',
        headerName: 'ID',
        description: 'This column has a value getter and is not sortable.',
        sortable: true,
        width: 60,
    },
    {
        field: 'externalId',
        headerName: 'External ID',
        description: 'This column has a value getter and is not sortable.',
        sortable: true,
        // editable: true,
        width: 100,
    },
    {
        field: 'name',
        headerName: 'Name',
        description: 'This column has a value getter and is not sortable.',
        sortable: true,
        width: 250,
    },
    {
        field: 'mcode',
        headerName: 'Code',
        description: 'This column has a value getter and is not sortable.',
        sortable: true,
        width: 150,
    },
    {
        field: 'service',
        headerName: 'Service',
        description: 'This column has a value getter and is not sortable.',
        sortable: true,
        width: 150,
    },
    {
        field: 'usageMarket',
        headerName: 'Market',
        description: 'This column has a value getter and is not sortable.',
        sortable: true,
        width: 150,
    },
    {
        field: 'territory',
        headerName: 'Territory',
        description: 'This column has a value getter and is not sortable.',
        sortable: true,
        width: 150,
    },

    {
        field: 'owner',
        headerName: 'Owner',
        description: 'This column has a value getter and is not sortable.',
        sortable: true,
        width: 150,
    },
    {
        field: 'status',
        headerName: 'Status',
        sortable: true,
        width: 150,
    },

];
